import { CommunityMap } from "@shared";
import { writable } from "../../utils/stores";
import { notEq } from "../utils";
export class CommunitySummaryUpdates {
    displayName = undefined;
    rulesAccepted;
    index;
    isEmpty() {
        return Object.values(this).every((v) => v === undefined);
    }
}
export const communitySummaryLocalUpdates = writable(new CommunityMap(), undefined, notEq);
